// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3uv_0","disabled":"FileBtn_disabled__8VYhr","warn":"FileBtn_warn__3HNnV","fade":"FileBtn_fade__337-F"};